import { OverlayRef } from '@angular/cdk/overlay';
import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppOverlayConfig, OverlayService } from 'src/app/Services/overlay.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'ze-base-overlay-form',
  templateUrl: './base-overlay-form.component.html',
  styleUrls: ['./base-overlay-form.component.scss']
})
export class BaseOverlayFormComponent implements OnInit {

  @Input() formConfig: any[];
  onSave: (form: FormGroup) => Observable<any>;
  myForm: FormGroup;
  error = '';
  formHeader = '';

  @ViewChild('baseOverlayFormRef', { static: false }) private baseOverlayFormRef: TemplateRef<any>;
  private baseOverlayFormConfig: AppOverlayConfig;
  private overlayRef: OverlayRef;

  constructor(private vcRef: ViewContainerRef,
    private overlayService: OverlayService,
    private _sharedService: SharedService,
    private fb: FormBuilder) { }

  ngOnInit() {
    const formGroupConfig = this.createFormGroupConfig(this.formConfig);
    this.myForm = this.fb.group(formGroupConfig);
    
    this.baseOverlayFormConfig = {
      hasBackdrop: true,
      backdropClass: 'overlay-backdrop-dark-class',
      positionStrategy: this.overlayService.positionGloballyCenter(),
      minWidth: '500px',
      minHeight: '300px',
      width: '500px',
      maxHeight: '500px',
    };
    this.overlayRef = this.overlayService.createOverlay(this.baseOverlayFormConfig);
    this._sharedService.openOverlayFormEvent.subscribe(data => {
      if (data[0] && !this.overlayRef.hasAttached()) {
        this.formConfig = data[1];
        this.formHeader = data[2];
        this.onSave = data[3];
        const formGroupConfig = this.createFormGroupConfig(this.formConfig);
        this.myForm = this.fb.group(formGroupConfig);
        this.overlayService.attachTemplatePortal(this.overlayRef, this.baseOverlayFormRef, this.vcRef);
      } else if (!data[0] && this.overlayRef.hasAttached()) {
        this.overlayRef.detach();
      }
    });
  }

  createFormGroupConfig(config: any[]): any {
    const group: any = {};

    config.forEach(field => {
      group[field.name] = [field.value || '', this.getValidators(field)];
    });

    return group;
  }

  getValidators(field: any): any[] {
    const validators: any[] = [];

    if (field.required) {
      validators.push(Validators.required);
    }
    return validators;
  }

  onSubmit() {
    if (this.onSave) {
      this.onSave(this.myForm).subscribe(
        data => {
          this.error = '';
          if(data == false) {
            this._sharedService.openOverlayFormEvent.emit([false]);
          }
        },
        error => {
          this.error = error;
        }
      );
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  cancel() {
    this._sharedService.openOverlayFormEvent.emit([false])
  }

}
